
import _ from 'lodash';

const files = require.context(`.`, false, /\.js$/);
const models = {};

files.keys().forEach(fileName => {
  if (fileName === `./index.js`) { return; }
  const modelName = _.camelCase(
    fileName.replace(/(\.\/|\.js)/g, ``)
  );
  models[`model/${modelName}`] = files(fileName).default;
});

export default models;
